import store from 'src/vuex';
export function getStringFromCharCode(dataView, start, length) {
  var str = '';
  var i;
  for (i = start, length += start; i < length; i++) {
    str += String.fromCharCode(dataView.getUint8(i));
  }
  return str;
}
export function base64ToArrayBuffer(base64) {
  base64 = base64.replace(/^data\:([^\;]+)\;base64,/gim, '');
  var binary = atob(base64);
  var len = binary.length;
  var buffer = new ArrayBuffer(len);
  var view = new Uint8Array(buffer);
  for (var i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }
  return buffer;
}
function getOrientation(arrayBuffer) {
  var dataView = new DataView(arrayBuffer);
  var length = dataView.byteLength;
  var orientation;
  var exifIDCode;
  var tiffOffset;
  var firstIFDOffset;
  var littleEndian;
  var endianness;
  var app1Start;
  var ifdStart;
  var offset;
  var i;
  // Only handle JPEG image (start by 0xFFD8)
  if (dataView.getUint8(0) === 0xff && dataView.getUint8(1) === 0xd8) {
    offset = 2;
    while (offset < length) {
      if (dataView.getUint8(offset) === 0xff && dataView.getUint8(offset + 1) === 0xe1) {
        app1Start = offset;
        break;
      }
      offset++;
    }
  }
  if (app1Start) {
    exifIDCode = app1Start + 4;
    tiffOffset = app1Start + 10;
    if (getStringFromCharCode(dataView, exifIDCode, 4) === 'Exif') {
      endianness = dataView.getUint16(tiffOffset);
      littleEndian = endianness === 0x4949;

      if (littleEndian || endianness === 0x4d4d /* bigEndian */) {
        if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002a) {
          firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);

          if (firstIFDOffset >= 0x00000008) {
            ifdStart = tiffOffset + firstIFDOffset;
          }
        }
      }
    }
  }
  if (ifdStart) {
    length = dataView.getUint16(ifdStart, littleEndian);

    for (i = 0; i < length; i++) {
      offset = ifdStart + i * 12 + 2;
      if (dataView.getUint16(offset, littleEndian) === 0x0112 /* Orientation */) {
        // 8 is the offset of the current tag's value
        offset += 8;

        // Get the original orientation value
        orientation = dataView.getUint16(offset, littleEndian);

        // Override the orientation with its default value for Safari (#120)
        if (/(iPhone|iPod|iPad).*AppleWebKit/i.test(navigator.userAgent)) {
          dataView.setUint16(offset, 1, littleEndian);
        }
        break;
      }
    }
  }
  return orientation;
}

function blobToFile(blob, name) {
  return new File(blob, name);
}

function dataURLtoBlob(dataurl) {
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
}

export function fileCompress(file) {
  let fileName = file.name,
    compressionRatio = 1;
  return new Promise((resolve, reject) => {
    let canvas = document.createElement('canvas');
    // 获取canvas
    let ctx = canvas.getContext('2d');
    let reader = new FileReader();
    reader.onload = (e) => {
      // target.result 该属性表示目标对象的DataURL
      let data = e.target.result;
      let buffer = base64ToArrayBuffer(data);
      let orientation = getOrientation(buffer);
      const canvasOrientationMap = {
        1: 0,
        3: 180,
        6: 90,
        8: -90,
      };
      orientation = canvasOrientationMap[orientation] || 0;

      let image = new Image();
      image.onload = (e) => {
        let { width, height } = image;
        if (image.width > 600 || image.height > 1000) {
          width = image.width * 0.5;
          height = image.height * 0.5;
        }
        let exchangeWidth = (orientation / 90) % 2 === 0,
          scaledWidth = exchangeWidth ? width : height,
          scaledHeight = exchangeWidth ? height : width,
          centerX = scaledWidth / 2,
          centerY = scaledHeight / 2;
        canvas.width = scaledWidth;
        canvas.height = scaledHeight;

        // 旋转
        ctx.translate(centerX, centerY);
        ctx.rotate((orientation * Math.PI) / 180);
        let resetCenterX = -centerX,
          resetCenterY = -centerY;
        if (!exchangeWidth) {
          resetCenterX = -centerY;
          resetCenterY = -centerX;
        }
        ctx.translate(resetCenterX, resetCenterY);

        ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
        // 坐标系还原
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        // //
        // let dpi = 2;
        // if (window.devicePixelRatio) {
        //   dpi = window.devicePixelRatio;
        // }
        // compressionRatio = compressionRatio / dpi;
        compressionRatio = store.getters.getIsIOS ? 0.4 : 0.5;
        let base64Data = canvas.toDataURL('image/jpeg', compressionRatio);
        let blobObj = dataURLtoBlob(base64Data);
        let localFile = blobToFile([blobObj], fileName);
        resolve(localFile);
      };
      image.onerror = (err) => {
        resolve(file);
      };
      image.src = data;
    };
    reader.onerror = (err) => {
      resolve(file);
    };
    // 传入一个参数对象即可得到基于该参数对象的文本内容
    reader.readAsDataURL(file);
  });
}
